module.exports = __webpack_public_path__ + "static/img/77.e44e28b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/77.png
// module id = CRYN
// module chunks = 0